<!-- TEMPLATE -->
<template>
  <div class="wrapper">
    <dean-dialog
      title="Telefoonnummerbereik toevoegen"
      :large="false"
      :addClose="true"
      @close="close"
    >
      <slot name="load">

      </slot>
      <dean-notification :is-modal="true">

      </dean-notification>

      <fade-transition group>
        <dean-form-row id="phoneNumberRangeFrom" label="telefoonnummer bereik start" type="string" v-model="data.phoneNumberRangeFrom"
                       key="phoneNumberRangeFrom"
                       :requiredField="true" :warning="$v.data.phoneNumberRangeFrom.$error"></dean-form-row>
        <dean-form-row id="phoneNumberRangeTo" label="telefoonnummer bereik einde" type="string" v-model="data.phoneNumberRangeTo"
                       key="phoneNumberRangeTo"
                       :requiredField="true" :warning="$v.data.phoneNumberRangeTo.$error"></dean-form-row>
      </fade-transition>

      <span slot="dean-dialog-button-group">
        <dean-button :danger="true" :dialog-button="true" @click.native="close()">Annuleren</dean-button>
        <dean-button :success="true" :dialog-button="true" @click.native="save()">Versturen</dean-button>
      </span>
    </dean-dialog>
  </div>
</template>

<!-- SCRIPT -->
<script lang="ts">
import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';
import axios from 'axios';
import {
    // SVG
    warningIcon,
    // COMPONENTS
    deanDialog,
    deanDialogButtonGroup,
  } from '@deanone/dean-components';
import deanSelectFormRow from '@/components/deanComponents/deanSelectFormRow.vue';
import deanButton from '@/components/deanComponents/deanButton.vue';
import DeanNotification from '@/components/deanComponents/deanNotification.vue';
import deanFormRow from '@/components/deanComponents/deanFormRow.vue';
import {deanDialogBus} from '@/main';
import {validationMixin} from 'vuelidate';
import {required} from 'vuelidate/lib/validators';
import {Validations} from 'vuelidate-property-decorators';
import {createNotificationFromData, validationMessage} from '@/mixins/validations';
import {FadeTransition} from 'vue2-transitions';
import {getErrorCodeFromResponse, getErrorMessageFromResponse, getErrorMessageFromTranslationByErrorCode} from "@/mixins/errorMessage";
import {internationalE164PhoneNumber, phoneNumberRange} from "@/mixins/validators";
import {OrderErrorTranslationsEnum, OrderErrorTranslationsEnumType} from "@/enums/OrderErrorTranslationsEnum";

@Component({
    components: {
      warningIcon,
      DeanNotification,
      deanDialog,
      deanButton,
      deanFormRow,
      deanSelectFormRow,
      deanDialogButtonGroup,
      FadeTransition,
    },
    mixins: [validationMixin],
  })

  export default class ProvisionServicesDialog extends Vue {
    @Validations()
    get validations() {
      const valData: any = {
        data: {
          phoneNumberRangeFrom: {
            required,
            internationalE164PhoneNumber,
            phoneNumberRange: phoneNumberRange(this.data.phoneNumberRangeFrom, this.data.phoneNumberRangeTo, this.payloadData.phoneNumberBlockSize),
          },
          phoneNumberRangeTo: {
            required,
            internationalE164PhoneNumber,
            phoneNumberRange: phoneNumberRange(this.data.phoneNumberRangeFrom, this.data.phoneNumberRangeTo, this.payloadData.phoneNumberBlockSize),
          },
        },
      };

      return valData;
    }

    // DATA
    @Prop() public payloadData!: {
      [key: string]: {
        [key: string]: string,
      };
    };
    public data: {[key: string]: any} = {
      phoneNumberRangeFrom: this.payloadData.phoneNumberRangeFrom,
      phoneNumberRangeTo: this.payloadData.phoneNumberRangeTo,
    };

    // METHODS
    public close() {
      deanDialogBus.$emit('close');
    }

    public save() {
      // @ts-ignore-next-line
      this.$v.data.$touch();

      if (!this.$v.$invalid) {
        this.$emit('setLoad', true);
        axios.post('/-/trade/api/order.line.add.phoneNumberRange', {
          orderLineId: this.payloadData.orderLineId,
          phoneNumberRangeFrom: this.data.phoneNumberRangeFrom,
          phoneNumberRangeTo: this.data.phoneNumberRangeTo,
        }).then(
          (response: any) => {
            deanDialogBus.$emit('saved');
            this.$toast(this.$store.state.main.notification.messages.dataSaved);
            this.close();
          },
          (error: any) => {
            const errorResponse = error.response.data;

            const errorCode: string | null = getErrorCodeFromResponse(errorResponse);

            if (errorCode) {
              const errorMessage = (OrderErrorTranslationsEnum as OrderErrorTranslationsEnumType)[errorCode];

              this.$toast(validationMessage(errorMessage));
            } else {
              this.$toast(this.$store.state.main.notification.messages.couldNotSendData);
            }
          },
        ).finally(() => {
          this.$emit('setLoad', false);
        });
      } else {
        this.$toast(createNotificationFromData(this.$v.data));
      }
    }

    public created() {
      this.$emit('setLoad', false);
    }
  }
</script>

<!-- STYLE -->
<style lang="scss" scoped>

:deep(.dialog .dean-dialog-container) {
  width: 500px;
}

</style>
